import { PersonaAutorizada } from "../PersonaAutorizada";

export class DatosEmisorBhe {
	emisorId: string;
	direccionEmisor: string;
	codigoDireccionEmisor: number;
	mostrarDescripcion: boolean;
	comunaEmisor: string;
	terceros: boolean;
	personaAutorizada: PersonaAutorizada;
}
